import { defineMessages, FormattedMessage } from 'react-intl'

export const headerMessages = defineMessages({
  name: { id: 'admin/promotions.list.name' },
  beginDate: { id: 'admin/promotions.list.begin-date' },
  endDate: { id: 'admin/promotions.list.end-date' },
  status: { id: 'admin/promotions.list.status' },
})

export function NameHeader() {
  return <FormattedMessage id="admin/promotions.list.name" />
}

export function FromHeader() {
  return <FormattedMessage id="admin/promotions.list.begin-date" />
}

export function ToHeader() {
  return <FormattedMessage id="admin/promotions.list.end-date" />
}

export function StatusHeader() {
  return <FormattedMessage id="admin/promotions.list.status" />
}
